import { getPeculiarSmell } from '../../../../api/eastCoastDataApi/device/PeculiarSmellApi'
import CONST from '../../../../utils/const'
import Utils from '../../../../utils/utils'

const state = {
  allPeculiarSmell: [],
  PeculiarSmellData: []
}

const getters = {
  getAllPeculiarSmell: state => {
    return state.allPeculiarSmell
  },
}

const actions = {
  async getPeculiarSmell({ commit }, condition) {
    commit('PeculiarSmell', await getPeculiarSmell(condition))
  },
}

const mutations = {
  PeculiarSmell(state, data) {
    if (Utils.isEmptyObject(data)) {
      return
    }

    state.allPeculiarSmell = data
    state.PeculiarSmellData = data
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}